import { css } from '@emotion/react'
import { cssVar } from '@opallabs/gem'

const rootClassName = 'lapidary-icon'
export const selectors = {
  root: rootClassName,
  svg: `${rootClassName}-svg`,
} as const
export const cssVariables = {
  color: `--${rootClassName}-color`,
  size: `--${rootClassName}-size`,
} as const
export const stateVariables = {
  clickable: 'is-clickable',
  square: 'is-square',
} as const

/**
 * For icons with multiple strokes or fill areas, we use this pink color
 * in our design systems to indicate that an icon's color can be changed.
 * By matching on this color code and applying "currentColor", we can be
 * explicit about which portions of an icons should be colorable.
 */
const FUNGIBLE_COLOR = '#FF3CA0'

export const root = css({
  color: cssVar(cssVariables.color),
  contain: 'content',
  display: 'flex',
  fill: cssVar(cssVariables.color),

  [`&.${stateVariables.clickable}`]: {
    cursor: 'pointer',
  },
  [`&.${stateVariables.square}, &.${stateVariables.square} .${selectors.svg}`]:
    {
      blockSize: cssVar(cssVariables.size),
      inlineSize: cssVar(cssVariables.size),
    },
  '@media (prefers-contrast: more)': {
    color: 'currentColor',
    fill: 'currentColor',
  },

  [`[fill="${FUNGIBLE_COLOR}"]`]: {
    fill: 'currentColor',
  },
})
